import module from 'finanzas/module.js'
import template from './template.html'

export class CargaMovimientosBancariosHistorialListaItemComponent {
  data
  titulo
  subtitulo
  editando = false
  eliminando = false
  onDelete

  $onInit () {
    this.titulo = (this.data.bancos.length === 1 ? this.data.bancos[0] : this.data.bancos.length + ' bancos') +
      (this.data.cuentas.length === 1 ? ' ' + this.data.cuentas[0] : ', ' + this.data.cuentas.length + ' cuentas')

    this.subtitulo = this.data.movimientos + ' movimientos'
  }

  eliminar () {
    this.onDelete()
  }
}

module.component('financesCargamovimientosbancariosHistorialListaItem', {
  controller: CargaMovimientosBancariosHistorialListaItemComponent,
  template,
  bindings: {
    data: '<',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/cargaMovimientosBancarios/historial/lista/item/component.js